import { MenuSection, ShowcaseBanner } from "../../components";
import { useAppContext } from "../../context/AppContext";

const Home = () => {
  const { products } = useAppContext();

  return (
    <div className="flex flex-col items-center justify-center w-full h-auto">
      <ShowcaseBanner products={products} />
      <MenuSection products={products} />
    </div>
  );
};

export default Home;
